import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Switch';
/**
 * @class NCSwitch
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCSwitch
 * @label 开关
 *
 */
class NCSwitch extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title 自动化Id
         * @description 自动化Id
         */
        fieldid: PropTypes.string,
        /**
         * @title 提示
         * @description 提示
         */
        showTip: PropTypes.bool,

    }
    static getCompMeta = () => {
        return CompMeta;
    }
    render() {
        return (
            <Switch {...this.props} />
        )
    }
}

export default NCSwitch;
